// Four wheeler
export const fourWheelerQuickQuoteFormCookiesKey = "4_wheeler_qq_form";
export const fourWheelerSelectedProductKey = "4_wheeler_selected_product";
export const fourWheelerCreateQuoteResponseKey =
  "4_wheeler_create_quote_response";

// Two wheeler
export const twoWheelerQuickQuoteFormCookiesKey = "2_wheeler_qq_form";
export const twoWheelerSelectedProductKey = "2_wheeler_selected_product";
export const twoWheelerCreateQuoteResponseKey =
  "2_wheeler_create_quote_response";

// GCV
export const gcvQuickQuoteFormCookiesKey = "gcv_qq_form";
export const gcvSelectedProductKey = "gcv_selected_product";
export const gcvCreateQuoteResponseKey = "gcv_create_quote_response";

// PCV
export const pcvQuickQuoteFormCookiesKey = "pcv_qq_form";
export const pcvSelectedProductKey = "pcv_selected_product";
export const pcvCreateQuoteResponseKey = "pcv_create_quote_response";

// Miscellaneous
export const miscQuickQuoteFormCookiesKey = "misc_qq_form";
export const miscSelectedProductKey = "misc_selected_product";
export const miscCreateQuoteResponseKey = "misc_create_quote_response";

export const motorCategoryKey = "motorCategory";

export const hdfcCISFormCheckKey = "hdfcCISFormCheck";

// Social Media URL
export const FACEBOOK_URL = "https://www.facebook.com/Acuvisorinsurance/";
export const INSTAGRAM_URL = "https://www.instagram.com/acuvisor/";
export const YOUTUBE_URL =
  "https://www.youtube.com/@acuvisorinsurancebrokersin8864";
export const LINKEDIN_URL =
  "https://www.linkedin.com/company/acuvisor-insurance-broker/posts/?feedView=all";
export const TWITTER_URL = "https://twitter.com/YourHandle";
